import { Component, OnInit } from '@angular/core';
import { CollectingStatesService } from '../collecting-states.service';
import { ProductIdentificationSource } from '../../../../types/product-identification-source';
import { CollectingItemsService } from '../collecting-items.service';
import {
    ProductIdentifyAction,
    ProductIdentifyService,
} from '../product-identify.service';

@Component({
    selector: 'app-actions-toolbar',
    templateUrl: './actions-toolbar.component.html',
    styleUrls: ['./actions-toolbar.component.scss'],
})
export class ActionsToolbarComponent implements OnInit {
    constructor(
        public states: CollectingStatesService,
        private _collectingItemsService: CollectingItemsService,
        private _productIdentifyService: ProductIdentifyService
    ) {}

    ngOnInit(): void {}

    get isMultiCollecting(): boolean {
        return this.states.multiCollectingStates?.length > 1;
    }

    public showCreateItemModal(): void {
        if (!this.states.isPaymentReserved) {
            this.states.setCreateItemModalVisible(true);
        }
    }

    public showBarcodeReader(): void {
        this.identify('barcode');
    }

    public showManualSKUCheckModal(): void {
        this.identify('sku');
    }

    private identify(action: ProductIdentifyAction): void {
        this.startProductIdentification(() =>
            this.isMultiCollecting
                ? this._productIdentifyService.openOrderSelectFor(action)
                : this._productIdentifyService.run(action)
        );
    }

    private startProductIdentification(open: () => void): void {
        this._collectingItemsService
            .checkIfOrderModificationIsBlocked(this.states.orderID)
            .subscribe((underInspection) => {
                if (!underInspection) {
                    this.states.productIdentificationSource =
                        ProductIdentificationSource.ToPick;
                    this.states.replaceableOrderItem = null;
                    open();
                }
            });
    }

    public hideAll() {
        var collapsedElementIDs = [
            'items-to-pick-body',
            'collected-items-body',
            'replaced-items-body',
            'missing-items-body'];

        collapsedElementIDs.forEach(collapsedElementID => {
            var collapsedElement = document.getElementById(collapsedElementID);
            collapsedElement.style.display = 'none';
        });
    }

    public show(id: string) {
        var body = document.getElementById(id + '-body');
        if (body) {
            body.style.display = 'block';
            var header = document.getElementById(id + '-header');
            if (header) {
                header.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
        }
    }
}
